<ng-content></ng-content>

<div class="grid-content">
    <ng-content select="[grid-element]"></ng-content>
</div>